module.exports = __webpack_public_path__ + "static/img/company-qr.b4abcef.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/company-qr.png
// module id = U2DI
// module chunks = 1